import { render, staticRenderFns } from "./RestrictedAddressQuestionnaire.vue?vue&type=template&id=25721d38&"
import script from "./RestrictedAddressQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./RestrictedAddressQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports